














































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./sales-statistics-columns";
import opsColumns from "./ops-sales-statistics-columns";
import clientColumns from "./client-sales-statistics-columns";
import AppConsts from "@/lib/appconst";
import * as moment from "moment";
import _ from "lodash";
class PageSalesStatisticsRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  warehouseCode: string;
  fromDate: Date;
  toDate: Date;
  status: string;
  customerId: number;
  outboundMode: string;
  assetTypeCode: string;
  conditionTypeCode: string;
}
@Component
export default class SalesStatistics extends mixins(ListMixin, AbpBase) {
  namespace = "salesStatistics";
  clients = [];
  warehouses = [];
  spinShow: boolean = false;
  //filters
  pagerequest: PageSalesStatisticsRequest = new PageSalesStatisticsRequest();
  creationTime: Date[] = [];
  statuses = [];
  assetTypes = [];
  conditionTypes = [];
  outboundModes = [];
  customers = [];
  customerLoading: boolean = false;
  viewDateWarning() {
    var argus = [AppConsts.reportRangeDays.range180.toString()];
    return Util.L("RangeDaysTooltip", "", ...argus);
  }
  get store() {
    return this.$store.state.salesStatistics;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        var re = this.$store.state.client.clientsForSelect;
        this.$set(
          this.pagerequest,
          "clientCode",
          re.length === 0 ? "" : re[0].code
        );
        this.clients = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.$set(
          this.pagerequest,
          "warehouseCode",
          re.length === 0 ? "" : re[0].id
        );
        this.warehouses = re;
      });
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: "saleOrder/getSoStatusesForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.saleOrder.soStatuses;
        this.pagerequest.status = re.length === 0 ? "" : re[0].code;
        this.statuses = re;
      });
  }
  async getOutboundModes() {
    await this.$store
      .dispatch({
        type: "saleOrder/getOutboundModesForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        this.outboundModes = result;
        this.pagerequest.outboundMode =
          this.outboundModes.length > 0 ? this.outboundModes[0].code : "";
      });
  }
  async getConditionTypes() {
    await this.$store
      .dispatch({
        type: "masterData/getFeatureConditionTypesForSelect",
        data: {
          featureCode: AppConsts.featureConditionType.SO_Create,
          hasAllItem: true,
        },
      })
      .then((result) => {
        this.conditionTypes = result;
        this.pagerequest.conditionTypeCode =
          this.conditionTypes.length > 0 ? this.conditionTypes[0].id : "";
      });
  }
  async getClientAssetTypes() {
    await this.$store
      .dispatch({
        type: "client/getClientAssetTypesForSelect",
        data: {
          code: this.pagerequest.clientCode,
          hasAllItem: true,
        },
      })
      .then((result) => {
        var re = result;
        this.$set(
          this.pagerequest,
          "assetTypeCode",
          re.length === 0 ? "" : re[0].id
        );
        this.assetTypes = re;
      });
  }
  //Customer
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.customerLoading = false;
  }
  //===================
  get list() {
    var re = this.$store.state.salesStatistics.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (this.creationTime.length > 0) {
      this.pagerequest.fromDate = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.toDate = this.creationTime[1];
    }
  }
  async exportToExcel() {
    this.preGetPage();
    if (
      Util.isNull(this.pagerequest.keyword) ||
      this.pagerequest.keyword === ""
    ) {
      this.pagerequest.keyword = AppConsts.allItemValue;
    }
    await this.$store.dispatch({
      type: "report/exportSalesStatistics",
      data: {
        keyword: this.pagerequest.keyword,
        clientCode: this.pagerequest.clientCode,
        warehouseCode: this.pagerequest.warehouseCode,
        fromDate: moment(this.pagerequest.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.pagerequest.toDate).format("YYYY-MM-DD"),
        status: this.pagerequest.status,
        customerId: this.pagerequest.customerId,
        outboundMode: this.pagerequest.outboundMode,
        assetTypeCode: this.pagerequest.assetTypeCode,
        conditionTypeCode: this.pagerequest.conditionTypeCode,
      },
    });
  }
  renderColumn() {
    if (this.isClient()) {
      return clientColumns.concat(columns);
    }
    if (this.isTenant()) {
      return opsColumns.concat(columns);
    }
    return opsColumns.concat(clientColumns).concat(columns);
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 80,
    },
    ...this.renderColumn(),
  ];
  async created() {
    this.spinShow = true;
    try {
      this.refreshListData();
      await this.getClients();
      await this.getWarehouses();
      await this.getStatuses();
      await this.getOutboundModes();
      await this.getConditionTypes();
      await this.getClientAssetTypes();
      this.creationTime = Util.buildDefaultViewDate(
        AppConsts.reportRangeDays.range180
      );
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
